import { useOfferDiscontinuedBanners } from '../../../MigrateOffer/hooks/useOfferDiscontinuedBanners/useOfferDiscontinuedBanners';
export const useProductBanners = ({ offerId, product, }) => {
    const productBanners = [];
    const offerDiscontinuedBanners = useOfferDiscontinuedBanners(offerId, product);
    productBanners.push(...offerDiscontinuedBanners);
    return {
        productBanners,
    };
};
